import * as React from "react"
import { Eye, EyeOff } from "lucide-react"

import { cn } from "@/lib/utils"

const WRAP_RX = /^(w-|min-w-|max-w-|flex-|basis-|grow|shrink|col-span|mx-auto|ml-|mr-|mt-|mb-|m-|self-|sm:w-|md:w-|lg:w-)/

/* Password <input> with a show / hide eye button. Width & margin classes move to the wrapper. */
export const PwInput = React.forwardRef(({ className = "", ...props }, ref) => {
  const [show, setShow] = React.useState(false)
  const parts = String(className).split(/\s+/).filter(Boolean)
  const wrap = parts.filter((c) => WRAP_RX.test(c.replace(/^!/, "")))
  const inner = parts.filter((c) => !wrap.includes(c))
  return (
    <span className={cn("relative inline-block align-middle", wrap.some((c) => /(^|:)w-|flex-1|basis-|grow/.test(c)) ? "" : "w-full", wrap)}>
      <input {...props} ref={ref} type={show ? "text" : "password"} className={cn(inner, "w-full pr-8")} />
      <button type="button" tabIndex={-1} onMouseDown={(e) => e.preventDefault()}
        onClick={(e) => { e.stopPropagation(); setShow((s) => !s) }}
        className="absolute right-1.5 top-1/2 -translate-y-1/2 rounded p-0.5 text-slate-400 hover:text-slate-700"
        aria-label={show ? "Hide password" : "Show password"}
        data-testid={props["data-testid"] ? `${props["data-testid"]}-eye` : "password-eye"}>
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </span>
  )
})
PwInput.displayName = "PwInput"
